import React, { useState } from 'react';

const DateRangePickerHandler = () => {
    const [open, setOpen] = useState(false);

    return { open, setOpen };
};

export default DateRangePickerHandler;
